import { ApiPropertyOptional } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsNumber, IsOptional, IsUUID, Max, Min } from 'class-validator';

export class AprobarMasivoDto {
  @ApiPropertyOptional({ description: 'Limitar a una búsqueda' }) @IsOptional() @IsUUID() busqueda_id?: string;
  @ApiPropertyOptional({ default: 0.9, minimum: 0.55, maximum: 1 })
  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  @Min(0.55)
  @Max(1)
  score_min?: number = 0.9;
}
